<script>
import { byAsc, pluckId } from '@utils/collections'
import { actions } from '@utils'
import { debounce } from '@utils/async'
import { sort } from 'rambda'

export default {
  data() {
    return {
      isFetchingLaptops: false,
      laptopEvaluations: [],
    }
  },
  computed: {
    laptopEvaluationsSorted() {
      return sort(byAsc('bucketIndex'), this.laptopEvaluations)
    },
  },
  methods: {
    fetchLaptops: (() => {
      return debounce(500, function() {
        return this.$wrap(async () => {
          const filtersMinimalScores = Object.fromEntries(Object
            .entries(this.criteria.minimalScores || {})
            .map(([key, value]) => [key, { $gte: value }]))

          const laptops = await this.FIND_LAPTOP_EVALUATION({
            articleId: this.article.id,
            activeLaptopIds: this.laptopIdsSelected,
            criteria: {
              ...this.criteria,
              filters: filtersMinimalScores,
              filtersLaptop: this.filtersLaptop,
            },
          })

          const laptopsActive = laptops
            .filter(laptop => (
              !laptop.isArchived ||
              !laptop.price ||
              this.laptopIdsSelected.includes(laptop.id)
            ))

          const laptopIds = pluckId('id', laptopsActive)
          await this.FETCH_MISSING_LAPTOP(laptopIds)

          this.laptopEvaluations = laptopsActive
        }, 'isFetchingLaptops')
      })
    })(),
    ...actions(
      'FETCH_MISSING_LAPTOP',
      'FIND_LAPTOP_EVALUATION',
    ),
  },
  watch: {
    criteria: {
      deep: true,
      immediate: true,
      handler: 'fetchLaptops',
    },
  },

  render: () => '',
}
</script>
